import { render, staticRenderFns } from "./PJCustomerDocuments.vue?vue&type=template&id=7c48d5d2"
import script from "./PJCustomerDocuments.vue?vue&type=script&lang=js"
export * from "./PJCustomerDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports